/**
 * fichier qui contient les chemins des endpoints de l'API
 */

export default {
    tod: {
        all: 'tod/all',
        count: 'tod/count'
    },
    pam: {
        all: 'pam/all',
        count: 'pam/count'
    },
    user: {
        getUser: 'users{/id}/all',
        getUserByLogin: 'users/login{/login}/all',
        getUserByGuid: 'users/guid{/guid}/all',
        base: 'users{/id}'
    },
    todNetworks: {
        base: 'todNetworks'
    },
    auth: {
        auth: 'login'
    },
    wdrUser: {
        getAll: 'users'
    }
}
